import Cookies from "universal-cookie";
const cookies = new Cookies();
// import jwtDecode from 'jwt-decode';
export const CURRENT_USER = "current-user";

//cookies
export const sessionTime = 7200000;
export const IedalTimeOut = 3000000; //The app will log off after 40 seconds of optimal screen time.

export function logOut() {
  cookies.remove(CURRENT_USER);
  cookies.remove(CURRENT_USER, { path: "/" });
  localStorage.clear();
  window.localStorage.clear();
  window.sessionStorage.clear();
  // cookies.remove(CURRENT_USER,{path:'/',domain:window.location.hostname});
}

export const addCookies = (token) => {
  logOut();
  cookies.set(CURRENT_USER, token, {
    path: "/",
    expires: new Date(Date.now() + sessionTime),
  });
};
export function getToken() {
  const token = cookies.get(CURRENT_USER);
  return token;
}
export function getCurrentUserInfo() {
  const tokenR = cookies.get(CURRENT_USER);
  return tokenR;
}

//session storage
export function setCurrentUser(user) {
  sessionStorage.setItem(CURRENT_USER, JSON.stringify(user));
}

export function getCurrentUser() {
  return JSON.parse(sessionStorage.getItem(CURRENT_USER));
}

export function clearCurrentUser() {
  sessionStorage.clear();
}
